import { render, staticRenderFns } from "./MonsterManager.vue?vue&type=template&id=6ae050fc"
import script from "./MonsterManager.vue?vue&type=script&lang=js"
export * from "./MonsterManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae050fc')) {
      api.createRecord('6ae050fc', component.options)
    } else {
      api.reload('6ae050fc', component.options)
    }
    module.hot.accept("./MonsterManager.vue?vue&type=template&id=6ae050fc", function () {
      api.rerender('6ae050fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/plot/components/MonsterManager.vue"
export default component.exports